import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-draft-button',
  templateUrl: './draft-button.component.html',
  styleUrls: ['./draft-button.component.css'],
})
export class DraftButtonComponent {
  @Input() name?: string;
  @Input() value: any;
  @Input() buttonType: 'button' | 'menu' | 'reset' | 'submit' = 'submit';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() classNames: string;
  @Input() tooltip: string;
  @Input() isDisabled: boolean = false;
  @Input() iconImage?: string;
  @Input() icon?: string;
  @Output() clickEmit: EventEmitter<any> = new EventEmitter();

  constructor() {}

  public trigger(val: any) {
    if (this.isDisabled) return;
    this.clickEmit.emit(val);
  }
}
